module.exports = __webpack_public_path__ + "img/dermCafe.1c9737c4.png";